module.exports = __webpack_public_path__ + "img/q4-9-active.ee3f7fa1.png";